import {ajax as Ajax, Loc, Dom} from 'main.core';

export class LeftMenu {

    static leftMenuCounter(arData) {
        const leftMenuContainer = BX('menu-items-block');

        setCounters();
        setNewElementButton();
        BX.addCustomEvent('onPullEvent-main', updateCounters);

        function setCounters() {
            if (!leftMenuContainer || !arData)
                return;

            arData.forEach(function (arMenuItem) {
                if (!arMenuItem.hasOwnProperty('counter'))
                    return;

                const menuItemCounter = parseInt(arMenuItem.counter),
                    curMenuitemId = arMenuItem.menu_item_id,
                    counterSpan = BX(arMenuItem.menu_item_counter_code);

                if (counterSpan) {
                    if (isNaN(menuItemCounter) || menuItemCounter === 0) {
                        BX.remove(counterSpan);
                    } else {
                        BX.adjust(counterSpan, {text: menuItemCounter})
                    }
                } else if (!isNaN(menuItemCounter) && menuItemCounter !== 0) {
                    const curMenuItemContainer = leftMenuContainer.querySelector('li[data-id="' + curMenuitemId + '"]');
                    if (curMenuItemContainer && !isNaN(menuItemCounter)) {
                        const curMenuItemSpanText = curMenuItemContainer.querySelector('.menu-item-link-text');
                        if (curMenuItemSpanText) {
                            const spanCounter = BX.create('span', {
                                    props: {className: 'menu-item-index'},
                                    attrs: {
                                        "data-role": "counter",
                                        "data-counter-value": menuItemCounter,
                                        id: arMenuItem.menu_item_counter_code
                                    },
                                    text: menuItemCounter
                                }),
                                spanWrapper = BX.create('span', {
                                    props: {className: 'menu-item-index-wrap'}
                                });

                            BX.append(spanCounter, spanWrapper);
                            BX.insertAfter(spanWrapper, curMenuItemSpanText);
                            BX.addClass(curMenuItemContainer, 'menu-item-with-index')
                        }
                    }
                }
            })
        }

        function updateCounters(command, params) {
            if (command !== 'user_counter' || !leftMenuContainer || !arData)
                return;

            arData.forEach(arMenuItem => {
                if (
                    params.hasOwnProperty(arMenuItem['site_id']) &&
                    params[arMenuItem['site_id']].hasOwnProperty(arMenuItem['menu_item_counter_code'])
                ) {
                    arMenuItem['counter'] = params[arMenuItem['site_id']][arMenuItem['menu_item_counter_code']];
                }
            });

            setCounters();
        }

        function setNewElementButton() {
            if (!leftMenuContainer || !arData)
                return;

            arData.forEach(function (arMenuItem) {
                if (!arMenuItem.hasOwnProperty('new'))
                    return;

                const curMenuitemId = arMenuItem.menu_item_id,
                    curMenuItemContainer = leftMenuContainer.querySelector('li[data-id="' + curMenuitemId + '"]');

                if (!curMenuItemContainer)
                    return;

                const curMenuLink = curMenuItemContainer.querySelector('a.menu-item-link');
                if (!curMenuLink)
                    return;

                const newElementLink = BX.Tag.render`
							<a href="${arMenuItem.new}" class="menu-item-plus">
							    <span class="menu-item-plus-icon"></span>
							</a>
						`;

                curMenuLink.before(newElementLink);
            })
        }
    }

}
